import { BorderRight } from "@mui/icons-material";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "55%",
      rows: {
        row1: [
          {
            name: "importInvoiceOtherDetailsPurchaseno",
            label: "Purchase Order No/Dt",
            component: "text-field",
            width: "43%",
          },
          {
            name: "importInvoiceOtherDetailsPurchaseDate",
            component: "DateSelector",
            width: "43%",
          },
        ],
        row2: [
          {
            name: "importInvoiceOtherDetailsContractno",
            label: "Contract No/Dt",
            component: "text-field",
            width: "43%",
          },
          {
            name: "importInvoiceOtherDetailsContractDate",
            component: "DateSelector",
            width: "43%",
          },
        ],
        row3: [
          {
            name: "importInvoiceOtherDetailsTermsofPayment",
            label: "Terms Of Payment",
            component: "dropdown",
            endIconName: LuChevronDown,
            width: "43%",
            options: [
              { label: "LC", value: "LC" },
              { label: "FOC", value: "FOC" },
              { label: "DP", value: "DP" },
              { label: "DA", value: "DA" },
              { label: "SD", value: "SD" },
              { label: "OTHERS", value: "OTHERS" },
            ],
          },
          {
            name: "ImportInvoiceOtherDetailsTermsofPaymentDetails",
            component: "text-field",
            width: "43%",
          },
        ],
        row4: [
          {
            name: "importInvoiceOtherDetailsLocNo",
            label: "Loc No/Dt",
            component: "text-field",
            width: "43%",
          },
          {
            name: "importInvoiceOtherDetailsLocDate",
            component: "DateSelector",
            width: "43%",
          },
        ],
        row5: [
          {
            name: "importInvoiceOtherDetailsValuationMethod",
            label: "Valuation Method",
            component: "dropdown",
            endIconName: LuChevronDown,
            width: "43%",
            options: [
              {
                label: "RULE 3(DETERMINATION OF METHOD OF VALUATION)",
                value: "RULE 3 (DETERMINATION OF METHOD OF VALUATION)",
              },
              {
                label: "RULR 4(TRANSACTION VALUE)",
                value: "RULR 4(TRANSACTION VALUE)",
              },
              {
                label: "RULE 5(IDENTICAL GOODS)",
                value: "RULE 5(IDENTICAL GOODS)",
              },
              {
                label: "RULE 6(SIMILAR GOODS)",
                value: "RULE 6(SIMILAR GOODS)",
              },
              {
                label: "RULE 7(DEDUCTIVE VALUE)",
                value: "RULE 7(DEDUCTIVE VALUE)",
              },
              {
                label: "RULE 7A(COMPUTED VALUE)",
                value: "RULE 7A(COMPUTED VALUE)",
              },
              {
                label: "RULE 8(RESIDUAL METHOD)",
                value: "RULE 8(RESIDUAL METHOD)",
              },
              { label: "OTH(OTHERS)", value: "OTH(OTHERS)" },
            ],
          },
          {
            name: "importInvoiceOtherDetailsValuationMethodDetails",
            component: "text-field",
            width: "43%",
          },
        ],
        row6: [
          {
            name: "importInvoiceOtherDetailsAnyotherRelevantInfo",
            actionText: "Any Other relevant info which has a bearing on value",
            component: "textarea",
            height: "50px",
            sx: {
              borderRadius: "10px",
            },
            width: "96%",
          },
        ],
        row7: [
          {
            name: "importInvoiceOtherDetailsIGM",
            label: "IGM",
            component: "dropdown",
            endIconName: LuChevronDown,
            width: "89%",

          },
        ],
        
      },
    },
    {
      column: "column2",
      columnWidth: "55%",
      rows: {
        row1: [
          {
            name: "importInvoiceOtherDetailsAEOCode",
            label: "AEO Code",
            component: "text-field",
            width: "90%",
          },
        ],
        row2: [
          {
            name: "importInvoiceOtherDetailsAEOCountry",
            label: "AEO country",
            component: "text-field",
            icon: LuSearch,
            width: "90%",
            type: "autocomplete",
            endpoint: "getCountry",
             },
        ],
        row3: [
          {
            name: "importInvoiceOtherDetailsAEORole",
            label: "AEO Role",
            component: "text-field",
            width: "90%",
          },
        ],
        row4: [
          {
            name: "importInvoiceOtherDetailsNatureofTrans",
            label: "Nature Of Trans",
            component: "dropdown",
            endIconName: LuChevronDown,
            width: "43%",
            options: [
              { label: "Sale", value: "Sale" },
              {
                label: "Sale on Consignment basis",
                value: "Sale on Consignment basis",
              },
              { label: "Hire", value: "Hire" },
              { label: "Rent", value: "Rent" },
              { label: "Gift", value: "Gift" },
              { label: "Sample", value: "Sample" },
              { label: "Free of Cost", value: "Free of Cost" },
              { label: "Replacement", value: "Replacement" },
              { label: "Others", value: "Others" },
            ],
          },
          {
            name: "importInvoiceOtherDetailsNatureofTransDetails",
            component: "text-field",
            width: "43%",
          },
        ],
        row5: [
          {
            name: "importInvoiceOtherDetailsSaleCondition",
            actionText: "Sale Condition",
            component: "textarea",
            height: "50px",
            sx: {
              borderRadius: "10px",
            },
            width: "96%",
          },
        ],
        row6: [
          {
            name: "importInvoiceOtherDetailsITCLicenseDetails",
            actionText: "ITC License Details",
            component: "textarea",
            height: "50px",
            sx: {
              borderRadius: "10px",
            },
            width: "96%",
          },
        ],
      },
    },
  ],
};
